export const words = {
  place: "Location",
  yes: "Yes",
  no: "No",
  new: "New",
  agb: "Terms and Conditions",
  agb_full: "General terms and conditions",
  datenschutzerklaerung: "Privacy policy",
  status: 'Status',
  company_name: "Company name",
  next_button: "Next",
  device_name: "Device name",
  to_connect: "Connect",
  pin: 'PIN',
  time: "Time",
  first_name: "First name",
  last_name: "Last name",
  code: 'Code',
  help: "Help",
  total_time: "Total time",
  latitude: "Latitude",
  longitude: "Longitude",
  accuracy: "Accuracy",
  timestamp: "Timestamp",
  device_id: "Device ID",
  active: "active",
  o_clock: " ",
  loading: "Loading",
  annotation: "Annotation",
  since: "since",
  camera: "Camera",
  map: "Map",
  gallery: "Gallery",
  work: "Work",
  employees: "Employees",
  login: 'Login',
  login_action: "Log in",
  calendar_week_abbreviation: 'KW',
  calendar: "Calendar",
  to_call: "Call",
  email: "E-mail",
  attachment: "Appendix",
  operational_planning: "Work schedule",
  to_scan: "Scan",
  download: "Download",
  export: "Export",
  to_document: "Document",
  checklist: "Checklist",
  checklists: "Checklists",
  password: "Password",
  confirmation: "Confirmation",
  confirm: "Confirm",
  confirmation_email: "Confirmation email",
  unknown: "Unknown",
  unknown_place: "Unknown location",
  unknown_plan: "Unnamed shift schedule",
  project_no: "Project number",
  project_file: "Project file",
  contact_person: "Contact person",
  overtime: "Overtime",
  timesheet: "Timetable",
  minustime: "Minus hours",
  back: "Back",
  undo: "Undo",
  clockout: "Clock out",
  clocked_out: "Clocked out",
  clockin: "Stamp in",
  clocked_in: "stamped",
  dismiss: "Dismiss",
  discard: "Reject",
  finish: "Finish",
  or: "or",
  copy: "Copy",
  qr_code: "QR code",
  documentation: "Time Recording & Documentation",
  attendance: "Tablet terminal",
  tiercontent: "Package Scope",
  start_now: "Get started now",
  skip: "Skip",
  logout_during_core_time: "Stamped out during core time",
  absent_during_core_time: "Absent during core time",
  distance: "Distance",
  km_reading: "Mileage",
  the_start: 'Start',
  the_end: "End",
  license_plate: "License plate",
  details: 'Details',
  hide: "hide",
  cost: "Costs",
  file: "File",
  address_book: "Address book",
  template_plural: "Templates",
  signature: "Signature",
  main_project: "Main project",
  main_projects: "Main projects",
  sub_projects: "Subprojects",
  scan_to_login_header: "QR code registration",
  description: "Description",
  project_location: "Project location",
  phone_number: "Phone number",
  project_info: "Project information",
  number_short: "No.",
  sketch: "Sketch",
  video: 'Video',
  delete: "Delete",
  send: "Submit",
  sending: "Send...",
  save: "Save",
  granted: "granted",
  pending: "pending",
  denied: "denied",
  customer: "Customer",
  mobile_number: "Phone number",
  ok: 'Ok',
  day: "day",
  tomorrow: "tomorrow",
  days: "Days | Day | Days",
  holidays: "holidays",
  vacation_days: "Vacation days",
  vacation_hours: "Vacation hours",
  request: "request",
  accept: "Accept",
  withdraw: "Withdraw",
  hour_account: "Hourly account",
  period: "period",
  to: "to",
  date: "Date",
  number: "number",
  message: "message",
  change: "edit",
  changed: "Changed",
  changed_fields: "Changed fields",
  type: "type",
  hour: "Hour",
  hours: "hours",
  hours_abbreviation: 'Std.',
  hours_with_amount: "{amount} Hours",
  end: "end",
  end_date: "End date",
  start_date: "Start date",
  absence: "Absence",
  month: "month",
  week: "Week",
  transcript: "Transcript",
  time_left: "remaining",
  transcript_tasks: "Tasks",
  add_task: "New",
  /** Differentiation in some languages (e.g. English) */
  from: "from",
  of: "from",
  of_hours: "of {hours} hours",
  of_hours_abbreviation: "from {hours} hrs.",
  /**************/

  used: "used",
  update: "Refresh",
  today: "today",
  correction: "Correction",
  work_time: "Working time",
  break: "Break",
  loading_time: "Loading time",
  driving_time: "Driving time",
  business_trip: "Business trip",
  project: "Project",
  special_one: "Special1",
  special_two: "Special2",
  clock: " ",
  search: "Search",
  operation: "Activity",
  day_protocol: "Daily protocol",
  continue: "next",
  total_duration: "Total time",
  duration: "Duration",
  hello: "Hello",
  close: "close",
  comment: "comment",
  small: "small",
  medium: "medium",
  large: "large",
  sharpie: "Sharpie",
  line: "Line",
  arrow: "Arrow",
  rectangle: "Rectangle",
  ellipse: 'Ellipse',
  text: 'Text',
  language_settings: "Language settings",
  clock_reminder: "Stamp reminder",
  individually: "Individual",
  from_o_clock: "from",
  to_o_clock: "to",
  eraser: "Eraser",
  edit: "Edit",
  legal_notes: "Legal",
  notes: "Notes",
  note: "Note",
  imprint: "Imprint",
  open_source_licenses: "Open Source License Terms",
  author: "Author",
  license_type: "License type",
  version: 'Version',
  substitute: "Representation",
  not_rated: "Not rated",
  weekly_working_hours: "Weekly working hours",
  show_less: "Show less",
  office_center: "Office Center",
  admin_view: "NFC management",
  register: "Register",
  shifts: {
    shift_attachments: "Attachments (layer)",
    shift_plan_attachments: "Attachments (shift plan)",
    shift_plan: "Shift schedule",
    shift: "Layer"
  },
  absences: {
    sick: "Sick leave (with pay)",
    vacation: "Vacation",
    workshop: "Seminar/Course",
    special_vacation: "Special leave",
    school: "School",
    working_time_account: "Working time account",
    holiday: "Public Holiday",
    other: "Other",
    driving_time: "Driving time",
    parental_leave: "Parental leave",
    excused_absent: "Absent excused (paid)",
    not_excused_absent: "Absence day unexcused",
    sick_industrial_accident: "Illness Industrial accident (LFZ)",
    short_time_work: "Short-time work",
    maternity_pay: "Maternity protection wage/Employment prohibition",
    sick_child: "Care for sick child with sick pay",
    sick_child_no_payment: "Care for sick child without sick pay",
    vacation_no_payment: "Unpaid leave",
    sick_before_short_time_work: "Sick pay/sickness before short-time work",
    weather_related_failure: "Failure due to weather",
    sick_short_time_work: "Sick leave during short-time work",
    sick_no_payment: "Sick leave without pay",
    company_vacation: "Company vacations",
    meals_14_euro: "Small catering allowance",
    meals_28_euro: "Large catering allowance"
  },
  image_editor: {
    font_size: "Font size",
    stroke_width: "Line width",
    stroke_color: "Line color",
    text_color: "Font color",
    rotate_left: "Turn to the left",
    rotate_right: "Rotate right",
    flip_horizontal: "Mirror horizontally",
    flip_vertical: "Mirror vertically"
  },
  travel_log: {
    method_of_transportation: "Means of transportation",
    company_car: "Company car",
    private_car: "Private car",
    rental_car: "Rental car",
    taxi: "Cab",
    public_transportation: "Public transportation",
    airplane: "Airplane",
    train: "Rail (long-distance public transport)",
    other: "Other",
    km_reading_start: "Mileage start",
    km_reading_end: "Mileage end",
    net_expenses: "Travel expenses (net)",
    tax: "Value added tax"
  },
  read_in: "Read in",
  currency: "Currency",
  reason: "Reason",
  label: 'Label',
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  break_alarm: "Break alarm clock",
  clockin_reminder: "Clock-in reminder",
  clockout_reminder: "Clock-out reminder"
};